<template>
    <VueSlickCarousel v-if="show" :swipeToSlide="true" ref=carousel :arrows="false" :dots="false" :variableWidth="true" :infinite="false" class="translation-belt">
        <div class="translation-item" 
            @mousewheel.passive="slideByScroll($event)" 
            @mousedown="startDrag" 
            @mouseup="showFullPhoto($event, items, index)" 
            v-for="(photo, index) in items" :key="index" 
            :style="{backgroundImage: 'url('+ photo.url +')'}"
        >
            <div class="translation-item__delete" v-if="isAuthor(photo) || canDelete" @mouseup.stop @mousedown.stop @click="$emit('deletePhoto', {photo, index})">
                <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
                    <path
                    d="M17 22H7a2 2 0 01-2-2V7H3V5h4V4a2 2 0 012-2h6a2 2 0 012 2v1h4v2h-2v13a2 2 0 01-2 2zM7 7v13h10V7H7zm2-3v1h6V4H9zm6 14h-2V9h2v9zm-4 0H9V9h2v9z"
                    />
                </svg>
            </div>
            <div v-if="!photo.url" class="card__avatar_loader">
                <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                  <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform 
                      attributeName="transform" 
                      attributeType="XML" 
                      type="rotate"
                      dur="1s" 
                      from="0 50 50"
                      to="360 50 50" 
                      repeatCount="indefinite" />
                </path>
              </svg>
              </div>
            <div class="translation-item-author" @mouseup.stop @click.stop="openUser(photo.author)" v-if="photo.author">
                <div class="translation-item-author__avatar" :style="{backgroundImage: 'url(' + photo.author.avatar + ')'}"></div>
                <p class="translation-item-author__name">{{ photo.author.firstname + ' ' + photo.author.lastname }}</p>
            </div>
            <p class="translation-item__info">{{ getDate(photo) }}</p>
        </div>
    </VueSlickCarousel>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    name: 'SliderPhoto',
    data() {
      return {
          start: null,
          show: true
      }
    },
    plugins: [VueSlickCarousel],
    props: {
        items: {
            type: Array,
            required: true
        },
        canDelete: {
            type: Boolean,
            required: false
        }
    },
    components: {
        VueSlickCarousel
    },
    computed: {
        
        getUser () {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        isAuthor(photo) {
           return this.getUser && photo.author ? photo.author.id === this.getUser.id : false
        },
        openUser(user) {
            this.$router.push({name: 'user', params: {id: user.id}})
        },
        getDate(photo) {
            return this.$moment(photo.date).locale('ru').calendar()
        },
        slideByScroll(event) {
            event.deltaY === 0 ? event.deltaX > 0 ? this.$refs.carousel.next() : this.$refs.carousel.prev() : '';
        },
        startDrag(event) {
            this.start = {
                x: event.clientX,
                y: event.clientY
            }
        },
        showFullPhoto(event, photos, active) {
            if(this.start){
                let x = Math.abs(this.start.x - event.clientX);
                if (x < 2) {
                    this.$store.dispatch('setPhotos', {photos: photos, active: active})
                    this.$store.dispatch('setPhotosState', true)
                }
            }
        }
    }
}
</script>